import React from 'react';
import { Drawer as MuiDrawer, DrawerProps } from '@mui/material';
import { OverlayProvider } from '../pages/layout/OverlayContext';

/**
 * Custom Drawer component that automatically provides overlay context.
 */
export const Drawer: React.FC<DrawerProps> = (props) => {
  return (
    <MuiDrawer {...props}>
      <OverlayProvider value={{ overlay: true }}>{props.children}</OverlayProvider>
    </MuiDrawer>
  );
};

export default Drawer;
